import React from "react";

import {
  Annotation as AnnotationType,
  isBoxAnnotation,
  isCollectionAnnotation,
  isPointAnnotation,
  isPolygonAnnotation,
} from "@perceptron/core/types";

import { BoundingBox } from "./BoundingBox";
import { PointAnnotationMarker } from "./PointAnnotationMarker";
import { Polygon } from "./Polygon";

interface AnnotationProps {
  annotation: AnnotationType;
}

export const Annotation = React.memo(function Annotation({ annotation }: AnnotationProps) {
  if (isBoxAnnotation(annotation)) {
    return (
      <BoundingBox
        pointBox={{
          id: annotation.id,
          label: annotation.label,
          coordinates: annotation.coordinates,
          boxType: annotation.boxType,
          source: annotation.source,
        }}
      />
    );
  }

  if (isPointAnnotation(annotation)) {
    return (
      <PointAnnotationMarker
        pointMarker={{
          id: annotation.id,
          label: annotation.label,
          coordinates: annotation.coordinates,
          source: annotation.source,
        }}
      />
    );
  }

  if (isPolygonAnnotation(annotation)) {
    return (
      <Polygon
        polygon={{
          id: annotation.id,
          label: annotation.label,
          coordinates: annotation.coordinates,
          source: annotation.source,
        }}
      />
    );
  }

  if (isCollectionAnnotation(annotation)) {
    return annotation.children.map((child) => {
      return <Annotation annotation={child} key={child.id} />;
    });
  }

  return null;
});
